import { handleChangeController } from '@redux/actions/form'
import { startAddSelectOptions } from '@redux/actions/selects'
import { removeError } from '@redux/actions/validator'
import { selectThemeColors } from '@utils'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ReactSelect from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { editCollectionRegister } from '../../../redux/actions/form'
import { serverRequest } from '../../../utility/helpers/Axios/serverRequest'
import { handleExtraUrl } from '../../../utility/helpers/handleFilter'
import { useCollection } from '../../../utility/hooks/useCollection'
import { InputValidator } from './InputValidator'

export const MultiSelect = (properties) => {
    const {
        name,
        label,
        collection,
        className = '',
        endPoint,
        placeholder = label,
        labelName = 'name',
        errMsg = 'Campo requerido',
        isClearable = true,
        onSelect,
        containerStyle = {},
        containerClassname = 'mt-1',
        styles = '',
        dataTarget = 'id',
        defecto = () => { },
        master = null,
        isDisabled = false,
        isEnum = false,
        isCreatable = false,
        customOptions = null
    } = properties

    const dispatch = useDispatch()
    const params = useParams()
    const { select, validator, form } = useSelector(state => state)
    const nodeForm = useCollection().getCollectionNode(form, collection, false, isEnum)

    const options = isEnum ? select[name] : select[endPoint]
    const data = isEnum ? nodeForm?.[name] : nodeForm

    const value = options?.filter(o => nodeForm?.[name]?.includes(o.value.toString())
        || nodeForm?.[name]?.includes(o.value)
        || data?.some(a => a?.[dataTarget] === o.value || a === o.value))
        || defecto()

    const ComponentSelector = !!isCreatable ? CreatableSelect : ReactSelect

    const handleChange = (target) => {
        if (validator.errors && validator.errors[name]) delete validator.errors[name]
        if (!collection) dispatch(handleChangeController(name, target.map(e => (e))))
        else {
            dispatch(editCollectionRegister(collection, isEnum ? {
                name,
                value: target.map(e => {
                    if (typeof e.value === 'string') return `${e.value}`
                    else return e.value
                })
            } : { name, value: target.map(e => (e)) }, isEnum, !isEnum))
        }
        dispatch(removeError(validator.errors))
        dispatch(handleChangeController('edited', true))
    }


    const getMasterAdditionalLogic = () => {
        if (master?.filter?.extraUrl) {
            return { ...master, filter: { ...master?.filter, extraUrl: handleExtraUrl(master?.filter?.extraUrl, params) } }
        } else {
            return (master?.filter || master?.or) ? master : master?.onChange(form[master?.name], dispatch)
        }
    }

    const handleCreate = async (newOption) => {
        const data = await serverRequest(endPoint, null, { name: newOption }, 'POST')
        dispatch(startAddSelectOptions(endPoint, endPoint, labelName, getMasterAdditionalLogic()))
        //dispatch(handleChangeController(name, [...nodeForm[name], data.id]))
    }

    useEffect(() => endPoint && dispatch(startAddSelectOptions(endPoint, isEnum ? name : endPoint, labelName, getMasterAdditionalLogic())), [form[master?.name]])

    return (
        <div className={containerClassname} style={{ ...containerStyle }}>
            {label && <label className="control-label d-flex justify-content-between">{label} {<InputValidator errMsg={errMsg} errors={validator.errors} target={name} />}</label>}
            <ComponentSelector
                key={`${name}_${collection?.join('_')}`}
                isClearable={isClearable}
                className={`${className} ${validator.errors && validator.errors[name] ? 'border-danger rounded' : ''}`}
                isDisabled={isDisabled ? isDisabled : (!isCreatable && (options?.length === 0 || !options) && (customOptions?.length === 0 || !customOptions))}
                name={name}
                classNamePrefix={'select'}
                theme={selectThemeColors}
                styles={styles}
                options={customOptions || options}
                value={value}
                placeholder={placeholder}
                isMulti={true}
                onChange={onSelect ? onSelect : handleChange}
                onCreateOption={handleCreate}
                formatCreateLabel={n => `Crear nuevo: ${n}`}
            />
        </div>
    )
}